
import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../../honcierge-api"
import { mapState } from "vuex"
import { AxiosError } from "axios"
import { ArticleState } from "src/store/articleType"

@Component({
  computed: {
    ...mapState("article", {
      articleId: (state) => (state as ArticleState).id,
      status: (state) => (state as ArticleState).status,
    }),
  },
})
export default class ChangeStatusButton extends Vue {
  //
  // Getters
  //
  get buttonClass(): string {
    if (this.buttonName === "公開" || this.buttonName === "承認依頼") {
      return "success ma-2"
    } else if (
      this.buttonName === "非公開" ||
      this.buttonName === "承認待ち" ||
      this.buttonName === "差し戻し"
    ) {
      return "error ma-2"
    } else {
      return ""
    }
  }

  private dialog = false

  @Prop()
  private buttonName!: string

  @Prop()
  private newStatus!: string

  //
  // Properties assigned via mapState
  //
  private articleId!: number
  private status!: string

  @Emit("emitStatus")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitStatus(status: string) {
    /** */
  }

  @Emit("emitErrorMessages")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitErrorMessages(messages: string[]) {
    /** */
  }

  //
  // Methods
  //
  private changeStatus(newStatus: string) {
    api
      .changeStatus(this.articleId, newStatus)
      .then((response) => {
        this.$toasted.success("ステータスを変更しました")

        const status = response.data.article.status
        this.emitStatus(status)

        this.dialog = false
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.emitErrorMessages(e.response.data.messages)
        }

        this.dialog = false
      })
  }
}
